import React from "react";
import { dC } from "../../lib/helpers";

export const Dot = ({ status, sz = 6 }: { status: string; sz?: number }) => (
  <span
    className={status === "running" ? "spinner" : ""}
    style={{
      display: "inline-block", width: sz, height: sz, borderRadius: "50%",
      backgroundColor: status === "running" ? undefined : dC(status),
      flexShrink: 0,
    }}
  />
);
